<template></template>
<script>
export default {
    name        :   'ViewBlockItemMixin',
    props       :   this.props ? this.props.concat('column_superseded') : ['column_superseded'],
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/ViewBlockItemMixin.vue